/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardRoomsIndexRouteImport } from './routes/dashboard/rooms/index'
import { Route as DashboardRankingIndexRouteImport } from './routes/dashboard/ranking/index'
import { Route as DashboardLocationsIndexRouteImport } from './routes/dashboard/locations/index'
import { Route as DashboardUsersNewRouteImport } from './routes/dashboard/users/new'
import { Route as DashboardUsersIdRouteImport } from './routes/dashboard/users/$id'
import { Route as DashboardSettingsIdRouteImport } from './routes/dashboard/settings/$id'
import { Route as DashboardRoomsEditRouteImport } from './routes/dashboard/rooms/edit'
import { Route as DashboardLocationsNewRouteImport } from './routes/dashboard/locations/new'
import { Route as DashboardLocationsIdViewRouteImport } from './routes/dashboard/locations/$id/view'
import { Route as DashboardLocationsIdEditRouteImport } from './routes/dashboard/locations/$id/edit'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/dashboard/users/',
  path: '/dashboard/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/dashboard/settings/',
  path: '/dashboard/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoomsIndexRoute = DashboardRoomsIndexRouteImport.update({
  id: '/dashboard/rooms/',
  path: '/dashboard/rooms/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRankingIndexRoute = DashboardRankingIndexRouteImport.update({
  id: '/dashboard/ranking/',
  path: '/dashboard/ranking/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLocationsIndexRoute = DashboardLocationsIndexRouteImport.update({
  id: '/dashboard/locations/',
  path: '/dashboard/locations/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersNewRoute = DashboardUsersNewRouteImport.update({
  id: '/dashboard/users/new',
  path: '/dashboard/users/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardUsersIdRoute = DashboardUsersIdRouteImport.update({
  id: '/dashboard/users/$id',
  path: '/dashboard/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsIdRoute = DashboardSettingsIdRouteImport.update({
  id: '/dashboard/settings/$id',
  path: '/dashboard/settings/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoomsEditRoute = DashboardRoomsEditRouteImport.update({
  id: '/dashboard/rooms/edit',
  path: '/dashboard/rooms/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLocationsNewRoute = DashboardLocationsNewRouteImport.update({
  id: '/dashboard/locations/new',
  path: '/dashboard/locations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardLocationsIdViewRoute =
  DashboardLocationsIdViewRouteImport.update({
    id: '/dashboard/locations/$id/view',
    path: '/dashboard/locations/$id/view',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardLocationsIdEditRoute =
  DashboardLocationsIdEditRouteImport.update({
    id: '/dashboard/locations/$id/edit',
    path: '/dashboard/locations/$id/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/locations/new': typeof DashboardLocationsNewRoute
  '/dashboard/rooms/edit': typeof DashboardRoomsEditRoute
  '/dashboard/settings/$id': typeof DashboardSettingsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/locations': typeof DashboardLocationsIndexRoute
  '/dashboard/ranking': typeof DashboardRankingIndexRoute
  '/dashboard/rooms': typeof DashboardRoomsIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/locations/$id/edit': typeof DashboardLocationsIdEditRoute
  '/dashboard/locations/$id/view': typeof DashboardLocationsIdViewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/locations/new': typeof DashboardLocationsNewRoute
  '/dashboard/rooms/edit': typeof DashboardRoomsEditRoute
  '/dashboard/settings/$id': typeof DashboardSettingsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/locations': typeof DashboardLocationsIndexRoute
  '/dashboard/ranking': typeof DashboardRankingIndexRoute
  '/dashboard/rooms': typeof DashboardRoomsIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/locations/$id/edit': typeof DashboardLocationsIdEditRoute
  '/dashboard/locations/$id/view': typeof DashboardLocationsIdViewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/locations/new': typeof DashboardLocationsNewRoute
  '/dashboard/rooms/edit': typeof DashboardRoomsEditRoute
  '/dashboard/settings/$id': typeof DashboardSettingsIdRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/users/new': typeof DashboardUsersNewRoute
  '/dashboard/locations/': typeof DashboardLocationsIndexRoute
  '/dashboard/ranking/': typeof DashboardRankingIndexRoute
  '/dashboard/rooms/': typeof DashboardRoomsIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/locations/$id/edit': typeof DashboardLocationsIdEditRoute
  '/dashboard/locations/$id/view': typeof DashboardLocationsIdViewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/dashboard'
    | '/dashboard/locations/new'
    | '/dashboard/rooms/edit'
    | '/dashboard/settings/$id'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/locations'
    | '/dashboard/ranking'
    | '/dashboard/rooms'
    | '/dashboard/settings'
    | '/dashboard/users'
    | '/dashboard/locations/$id/edit'
    | '/dashboard/locations/$id/view'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/dashboard'
    | '/dashboard/locations/new'
    | '/dashboard/rooms/edit'
    | '/dashboard/settings/$id'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/locations'
    | '/dashboard/ranking'
    | '/dashboard/rooms'
    | '/dashboard/settings'
    | '/dashboard/users'
    | '/dashboard/locations/$id/edit'
    | '/dashboard/locations/$id/view'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/dashboard/'
    | '/dashboard/locations/new'
    | '/dashboard/rooms/edit'
    | '/dashboard/settings/$id'
    | '/dashboard/users/$id'
    | '/dashboard/users/new'
    | '/dashboard/locations/'
    | '/dashboard/ranking/'
    | '/dashboard/rooms/'
    | '/dashboard/settings/'
    | '/dashboard/users/'
    | '/dashboard/locations/$id/edit'
    | '/dashboard/locations/$id/view'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardLocationsNewRoute: typeof DashboardLocationsNewRoute
  DashboardRoomsEditRoute: typeof DashboardRoomsEditRoute
  DashboardSettingsIdRoute: typeof DashboardSettingsIdRoute
  DashboardUsersIdRoute: typeof DashboardUsersIdRoute
  DashboardUsersNewRoute: typeof DashboardUsersNewRoute
  DashboardLocationsIndexRoute: typeof DashboardLocationsIndexRoute
  DashboardRankingIndexRoute: typeof DashboardRankingIndexRoute
  DashboardRoomsIndexRoute: typeof DashboardRoomsIndexRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardLocationsIdEditRoute: typeof DashboardLocationsIdEditRoute
  DashboardLocationsIdViewRoute: typeof DashboardLocationsIdViewRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/dashboard/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/rooms/': {
      id: '/dashboard/rooms/'
      path: '/dashboard/rooms'
      fullPath: '/dashboard/rooms'
      preLoaderRoute: typeof DashboardRoomsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/ranking/': {
      id: '/dashboard/ranking/'
      path: '/dashboard/ranking'
      fullPath: '/dashboard/ranking'
      preLoaderRoute: typeof DashboardRankingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/locations/': {
      id: '/dashboard/locations/'
      path: '/dashboard/locations'
      fullPath: '/dashboard/locations'
      preLoaderRoute: typeof DashboardLocationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/users/new': {
      id: '/dashboard/users/new'
      path: '/dashboard/users/new'
      fullPath: '/dashboard/users/new'
      preLoaderRoute: typeof DashboardUsersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/users/$id': {
      id: '/dashboard/users/$id'
      path: '/dashboard/users/$id'
      fullPath: '/dashboard/users/$id'
      preLoaderRoute: typeof DashboardUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/settings/$id': {
      id: '/dashboard/settings/$id'
      path: '/dashboard/settings/$id'
      fullPath: '/dashboard/settings/$id'
      preLoaderRoute: typeof DashboardSettingsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/rooms/edit': {
      id: '/dashboard/rooms/edit'
      path: '/dashboard/rooms/edit'
      fullPath: '/dashboard/rooms/edit'
      preLoaderRoute: typeof DashboardRoomsEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/locations/new': {
      id: '/dashboard/locations/new'
      path: '/dashboard/locations/new'
      fullPath: '/dashboard/locations/new'
      preLoaderRoute: typeof DashboardLocationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/locations/$id/view': {
      id: '/dashboard/locations/$id/view'
      path: '/dashboard/locations/$id/view'
      fullPath: '/dashboard/locations/$id/view'
      preLoaderRoute: typeof DashboardLocationsIdViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/locations/$id/edit': {
      id: '/dashboard/locations/$id/edit'
      path: '/dashboard/locations/$id/edit'
      fullPath: '/dashboard/locations/$id/edit'
      preLoaderRoute: typeof DashboardLocationsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardLocationsNewRoute: DashboardLocationsNewRoute,
  DashboardRoomsEditRoute: DashboardRoomsEditRoute,
  DashboardSettingsIdRoute: DashboardSettingsIdRoute,
  DashboardUsersIdRoute: DashboardUsersIdRoute,
  DashboardUsersNewRoute: DashboardUsersNewRoute,
  DashboardLocationsIndexRoute: DashboardLocationsIndexRoute,
  DashboardRankingIndexRoute: DashboardRankingIndexRoute,
  DashboardRoomsIndexRoute: DashboardRoomsIndexRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardLocationsIdEditRoute: DashboardLocationsIdEditRoute,
  DashboardLocationsIdViewRoute: DashboardLocationsIdViewRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
